function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { useGlobalValue } from "../../../state/GlobalProvider";
import Icon from "../../Icon/Icon";
import styles from "./FloatButton.module.sass";
const FloatButton = props => {
  const {
    className,
    offset,
    icon,
    ...attributes
  } = props;
  const {
    theme
  } = useGlobalValue();
  const headerHeight = parseInt(((theme || {}).layout || {}).$headerHeight || "0", 10);
  const buttonIcon = icon ? /*#__PURE__*/React.createElement(Icon, {
    className: styles["icon"],
    name: icon
  }) : null;
  return /*#__PURE__*/React.createElement("button", _extends({
    style: offset ? {
      top: `${headerHeight + offset}px`
    } : null,
    className: `${styles["button"]} ${className || ""}`
  }, attributes), buttonIcon);
};
export default FloatButton;